import axios from "axios";

const apiUrl = `${process.env.REACT_APP_API_URL}/api/rdv-agenda`;
const token = localStorage.getItem("token");

/// GET
export const getAllRDV = async () => {
  try {
    const response = await axios.get(`${apiUrl}/all`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    if (response.status !== 200) throw new Error("Failed to fetch RDV data");
    return response.data;
  } catch (error) {
    console.error("Erreur lors du chargement des rendez-vous:", error);
    return [];
  }
};

export const getRDVById = async (id) => {
  try {
    const response = await axios.get(`${apiUrl}/byId/${id}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    if (response.status !== 200) throw new Error("Failed to fetch RDV by ID");
    return response.data;
  } catch (error) {
    console.error("Erreur lors de la récupération du RDV par ID:", error);
    return null;
  }
};

/// POST
export const addRDV = async (newRDV) => {
  try {
    const response = await axios.post(`${apiUrl}/add`, newRDV, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    if (response.status !== 201) throw new Error("Failed to add new RDV");
    return response.data;
  } catch (error) {
    console.error("Erreur lors de l'ajout du rendez-vous:", error);
    return null;
  }
};

/// PUT
export const updateRDV = async (rdv) => {
  try {
    const response = await axios.put(`${apiUrl}/update/${rdv.id}`, rdv, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    if (response.status !== 200) throw new Error("Failed to update RDV");
    return response.data;
  } catch (error) {
    console.error("Erreur lors de la modification du rendez-vous:", error);
    return null;
  }
};

/// PUT
export const updateClientRDV = async (rdv) => {
  try {
    const response = await axios.put(`${apiUrl}/update-client/${rdv.id}`, rdv, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    if (response.status !== 200) throw new Error("Failed to update RDV");
    return response.data;
  } catch (error) {
    console.error("Erreur lors de la modification du rendez-vous:", error);
    return null;
  }
};

/// DELETE
export const deleteRDV = async (id) => {
  try {
    const response = await axios.delete(`${apiUrl}/delete/${id}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    if (response.status !== 200) throw new Error("Failed to delete RDV");
    return response.data;
  } catch (error) {
    console.error("Erreur lors de la suppression du rendez-vous:", error);
    return null;
  }
};
